import React from 'react';
import './Matcher_invite.css';
import GGApi from '../../../utils/GGApi';
import GG_loader from '../../general_components/GG_loader/GG_loader';
import MasterButton from '../../general_components/MasterButton/MasterButton';
import GG_confetti from '../../general_components/GG_confetti/GG_confetti';

function formatDate(ymd) {
  if (!ymd) return '—';
  const s = String(ymd);
  if (s.length >= 10) return s.slice(0, 10).replace(/-/g, '/');
  return s;
}

class Matcher_invite extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      invalid: false,
      error: null,
      details: null,
      already_confirmed: false,
      confirming: false,
      confirmed: false,
    };
    this.handleConfirm = this.handleConfirm.bind(this);
  }

  getToken() {
    const search = this.props.location && this.props.location.search ? this.props.location.search : '';
    const params = new URLSearchParams(search);
    return params.get('t') || '';
  }

  componentDidMount() {
    const token = this.getToken();
    if (!token) {
      this.setState({ loading: false, invalid: true });
      return;
    }
    GGApi.get_matcher_invite_details(token)
      .then((data) => {
        if (data.invalid || data.message) {
          this.setState({ loading: false, invalid: true, error: data.message });
          return;
        }
        if (data.already_confirmed) {
          this.setState({ loading: false, details: data, already_confirmed: true });
          return;
        }
        this.setState({ loading: false, details: data });
      })
      .catch(() => this.setState({ loading: false, invalid: true, error: 'Something went wrong.' }));
  }

  handleConfirm() {
    const token = this.getToken();
    if (!token || this.state.confirming || this.state.confirmed) return;
    this.setState({ confirming: true });
    GGApi.confirm_matcher_invite(token)
      .then((data) => {
        if (data.success) {
          this.setState({ confirming: false, confirmed: true });
        } else {
          this.setState({ confirming: false, error: data.message || 'Could not confirm.' });
        }
      })
      .catch(() => this.setState({ confirming: false, error: 'Something went wrong. Please try again.' }));
  }

  render() {
    const { loading, invalid, error, details, already_confirmed, confirming, confirmed } = this.state;

    if (loading) {
      return (
        <div className="matcher_invite_wrapper">
          <main className="matcher_invite_main">
            <GG_loader />
          </main>
        </div>
      );
    }

    if (invalid || error) {
      return (
        <div className="matcher_invite_wrapper">
          <main className="matcher_invite_main matcher_invite_card">
            <h1 className="matcher_invite_title">Invalid or expired link</h1>
            <p className="matcher_invite_text">
              This invite link is invalid or has expired. If you have questions, please contact the person who invited you or email our support team.
            </p>
          </main>
        </div>
      );
    }

    if (already_confirmed && details) {
      return (
        <div className="matcher_invite_wrapper">
          <main className="matcher_invite_main matcher_invite_card">
            <h1 className="matcher_invite_title">You&apos;re already confirmed</h1>
            <p className="matcher_invite_text">
              You&apos;ve already confirmed that you&apos;ll match gifts for <strong>{details.account_name}</strong>. You&apos;ll receive a monthly summary when there are qualified gifts to match.
            </p>
          </main>
        </div>
      );
    }

    if (confirmed) {
      return (
        <div className="matcher_invite_wrapper">
          <GG_confetti />
          <main className="matcher_invite_main matcher_invite_card">
            <h1 className="matcher_invite_title green_text">You&apos;re all set!</h1>
            <p className="matcher_invite_text">
              You&apos;ve confirmed that you&apos;ll match gifts for <strong>{details && details.account_name}</strong>. When there are qualified gifts in a given month, we&apos;ll send you a summary and a link to confirm matching for that month.
            </p>
          </main>
        </div>
      );
    }

    if (!details) return null;

    return (
      <div className="matcher_invite_wrapper">
        <main className="matcher_invite_main">
          <div className="matcher_invite_card matcher_invite_top">
            <h1 className="matcher_invite_title">You&apos;re invited to match gifts</h1>
            <p className="matcher_invite_intro">
              <strong>{details.matcher_name}</strong> has invited you to help match gifts for <strong>{details.account_name}</strong>.
            </p>
            <div className="matcher_invite_details">
              <p className="small_text"><span className="matcher_invite_label">Match rate:</span> <span className="green_text">2x</span></p>
              <p className="small_text"><span className="matcher_invite_label">Monthly match limit:</span> <span className="matcher_invite_value">${Number(details.monthly_cap_dollars) || 0}/month</span></p>
              <p className="small_text"><span className="matcher_invite_label">Matching until:</span> <span className="matcher_invite_value">{formatDate(details.end_date)}</span></p>
            </div>
            <p className="matcher_invite_confirm_copy">
              By confirming, you agree to match gifts according to these terms. You&apos;ll receive a monthly summary with a link to submit payments for matching when there are qualified gifts.
            </p>
            <div className="matcher_invite_actions">
              <MasterButton
                buttonText={confirming ? 'Confirming…' : 'CONFIRM'}
                handleButtonClick={this.handleConfirm}
                notSticky={true}
                inactive_button={confirming}
                disabled={confirming}
              />
            </div>
          </div>

          <div className="matcher_invite_card matcher_invite_explanation">
            <h2 className="matcher_invite_subtitle" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span className="material-icons-outlined inline_icon step2_help_icon">
                  help
                </span>
                How gift matching works
                <span className="material-icons-outlined inline_icon step2_help_icon">
                  help
                </span>
                
            </h2>
            <p className="matcher_invite_text">
              When someone gives a gift to a child&apos;s plan, matchers like you can add a matching amount, multiplying the impact of the gift.  
              <br></br>
              <br></br>By setting a monthly cap you control how much you match each month.
            </p>
            <p className="matcher_invite_text">
              When there are qualified gifts in a given month, Greatest Gift will send you a summary and a link to confirm and complete your matching for that month. No need to sign up for a Greatest Gift account - you can manage everything via the links we send.
            </p>
            <p className="matcher_invite_text">
              If you have any questions, please email our support team and we&apos;ll be happy to help.
            </p>
          </div>
        </main>
      </div>
    );
  }
}

export default Matcher_invite;
